export default __webpack_public_path__ + "static/media/google-cloud.647bbeef.png";